export const styles = {
  display: { base: 'none', md: 'flex' },
};
